import { Autocomplete, TextField } from '@mui/material';
import { useReferentielijst, type Referentielijst } from '../api/referentie.ts';

interface Props<T extends { id: string; naam: string }, I> {
  lijst: Referentielijst<T, I>;
  label: string;
  waarde: string;
  onChange: (id: string) => void;
}

/**
 * Een filter op een referentielijst, zoals talentpool of functietitel, buiten een formulier. De hele lijst wordt
 * geladen, zodat de gekozen waarde uit het adres meteen een naam heeft.
 * @param props De referentielijst, het label, het gekozen id en wat er bij een keuze gebeurt.
 * @returns Het filter.
 */
export function ReferentieFilter<T extends { id: string; naam: string }, I>({
  lijst,
  label,
  waarde,
  onChange,
}: Props<T, I>) {
  const query = useReferentielijst(lijst);
  const opties = query.data ?? [];
  const gekozen = opties.find((item) => item.id === waarde) ?? null;
  return (
    <Autocomplete<T, false, false, false>
      options={opties}
      value={gekozen}
      onChange={(_gebeurtenis, item) => onChange(item?.id ?? '')}
      getOptionLabel={(item) => item.naam}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      loading={query.isPending}
      size="small"
      sx={{ minWidth: 220 }}
      renderInput={(parameters) => <TextField {...parameters} label={label} />}
    />
  );
}
